import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `BulletRangeDirective` directive represent a ranges of the react BulletChart.
 * ```tsx
 * <BulletChartComponent>
 * <BulletRangeCollectionDirective>
 * <BulletRangeDirective></BulletRangeDirective>
 * </BulletRangeCollectionDirective>
 * </BulletChartComponent>
 * ```
 */
export class BulletRangeDirective extends ComplexBase {
}
BulletRangeDirective.moduleName = 'bulletRange';
export class BulletRangeCollectionDirective extends ComplexBase {
}
BulletRangeCollectionDirective.propertyName = 'ranges';
BulletRangeCollectionDirective.moduleName = 'bulletRangeCollection';
